import { render, staticRenderFns } from "./CellClassificationModal.vue?vue&type=template&id=370c897e&scoped=true&"
import script from "./CellClassificationModal.vue?vue&type=script&lang=js&"
export * from "./CellClassificationModal.vue?vue&type=script&lang=js&"
import style0 from "./CellClassificationModal.vue?vue&type=style&index=0&id=370c897e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "370c897e",
  null
  
)

export default component.exports